import { useState } from 'react';

const useInfiniteScroll = (targetDiv, threshhold) => {

  const [isNearBottom, setIsNearBottom] = useState(false);

  const handleScroll = () => {
    const container = targetDiv.current;
    const scrollPosition = container?.scrollTop;
    const scrollHeight = container?.scrollHeight;
    const containerHeight = container?.clientHeight;

    const distanceFromBottom = scrollHeight - scrollPosition - containerHeight;
    const threshold = threshhold; // Adjust this threshold as needed

    setIsNearBottom(distanceFromBottom <= threshold);
  };

  return [isNearBottom, handleScroll, setIsNearBottom];

};
export default useInfiniteScroll;
